interface WorkoutSetWithRound {
  round?: number | null;
}

interface DisplayWorkoutSetsOptions {
  hideTemplateSets: boolean;
  isRoundBased: boolean;
}

export function getDisplayWorkoutSets<TSet extends WorkoutSetWithRound>(
  workoutSets: TSet[],
  options: DisplayWorkoutSetsOptions,
): TSet[] {
  if (!options.isRoundBased) {
    return workoutSets;
  }

  const roundSets = workoutSets.filter((workoutSet) => {
    return workoutSet.round != null;
  });

  if (options.hideTemplateSets || roundSets.length > 0) {
    return roundSets;
  }

  return workoutSets;
}
